import React from 'react';
import { Link } from 'react-router-dom';
import InfoTooltip from './InfoTooltip';

type DashboardCardProps = {
  title: string;
  value?: string | number;
  children?: React.ReactNode;
  info?: string;
  linkTo?: string;
};

const CARD_CLASSES = 'bg-white shadow rounded p-6 flex flex-col gap-2 h-48 w-64';

const DashboardCard: React.FC<DashboardCardProps> = ({ title, value, children, info, linkTo }) => {
  const body = (
    <>
      <div className="flex items-center gap-1.5">
        <h2 className="text-base font-medium text-gray-600">{title}</h2>
        {info && <InfoTooltip text={info} />}
      </div>
      {value !== undefined && <p className="text-3xl font-bold text-gray-900">{value}</p>}
      {children}
    </>
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className={`${CARD_CLASSES} hover:shadow-md transition-shadow`}>
        {body}
      </Link>
    );
  }

  return <div className={CARD_CLASSES}>{body}</div>;
};

export default DashboardCard;
